import { useEffect, useRef, useState } from "react";
import { Fetch } from "../../../shared/Fetch";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { format } from "date-fns";

interface IProps {
    reload: boolean;
    toast: any
}

export interface IMassMailRequestServingSetting {
    id?: number,
    request_Serving_Limit?: number | null,
    request_Serving_Wait_Time?: number | null,
    last_Serving_Time?: Date | null,
    updated_By?: string,
    updated_At?: Date,
}

export const EmptyMassMailSetting: IMassMailRequestServingSetting = {
    request_Serving_Limit: null,
    request_Serving_Wait_Time: null,
};

export const MassMailRequestServingSettingTable = (props: IProps) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false, } as { tableData: Array<IMassMailRequestServingSetting>; loading: boolean });
    const dt = useRef<any>(null);

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("MassMail/getMailsServingRequestSetting", "GET", null, null, props.toast);
        if (response) {
            const data: Array<IMassMailRequestServingSetting> = await response.json();
            setTableData({ tableData: data, loading: false });
        }
    };

    const pDate = (rowData: IMassMailRequestServingSetting) => {
        let date;
        if (rowData.last_Serving_Time) date = format(new Date(rowData.last_Serving_Time), 'dd/MM/yyyy HH:mm').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };

    useEffect(() => {
        loadTableData();
    }, [props.reload]);

    return (
        <>
            <DataTable style={{ border: "1px solid rgba(105,105,105,0.17)", borderTopWidth: "0", }}
                size="small" ref={dt} value={tableData.tableData} emptyMessage="No Data found."
                loading={tableData.loading} showGridlines stripedRows responsiveLayout="scroll"
            >
                <Column field="request_Serving_Limit" header="Request Serving Limit" />
                <Column field="request_Serving_Wait_Time" header="Next Request Serving Wait Time (in minutes)" />
                <Column field="last_Serving_Time" header="Last Request Served Time" body={pDate} />
            </DataTable>
        </>
    );
};